import { gql } from "@apollo/client";

export const getCampaignListing = gql`
  query ListCampaigns($filter: CampaignFilter) {
    listCampaigns(filter: $filter) {
      id
      title
      titleShort
      category
      type
      activeStartDate
      activeEndDate
      segments
      campaignStatus
      displayPosition
      imageUrl
      hasSegments
      activityTypes
      endless
      uniqueSegmentedUsersCount
      activities {
        id
        name
        description
        activityData
        activityRules {
          id
          ruleData
        }
      }
      rewardGroups {
        id
        type
        amount
      }
      campaignContent {
        contentData
      }
    }
  }
`;

export const getCampaignsTaggedToCodeGroup = gql`
  query listCampaigns($filter: CampaignFilter) {
    listCampaigns(filter: $filter) {
      id
      title
      activityTypes
      activeStartDate
      segments
      codeGroups
    }
  }
`;

export const getActiveCampaignsList = gql`
  query ListCampaigns($filter: CampaignFilter) {
    listCampaigns(filter: $filter) {
      id
      title
      titleShort
      type
      activeStartDate
      activeEndDate
      campaignContent {
        title
        description
        contentData
      }
    }
  }
`;

export const getCampaignsName = gql`
  query ListCampaigns($filter: CampaignFilter) {
    listCampaigns(filter: $filter) {
      id
      title
      titleShort
    }
  }
`;

export const listCampaignsLeaderboardIds = gql`
  query ListCampaigns {
    listCampaigns {
      leaderboards
    }
  }
`;
export const listCampaignsSweepstakesIds = gql`
  query ListCampaigns {
    listCampaigns {
      id
      sweepstakes
    }
  }
`;
export const listCampaignsInstantWinsIds = gql`
  query ListCampaigns {
    listCampaigns {
      instantWins
      title
    }
  }
`;

export const listCampaignsByLeaderboard = gql`
  query ListCampaigns($leaderboardId: [String]) {
    listCampaigns(filter: { leaderboards: $leaderboardId }) {
      id
      leaderboards
      title
    }
  }
`;
